import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { CheckCircle2, AlertTriangle, XCircle, WifiOff } from "lucide-react";
import type { ComparisonStatus } from "src/@types/campaign-comparison";

interface ComparisonStatusBadgeProps {
  status: ComparisonStatus;
  className?: string;
}

const STATUS_CONFIG: Record<
  ComparisonStatus,
  {
    variant: "default" | "secondary" | "destructive" | "outline";
    label: string;
    icon: typeof CheckCircle2;
    className?: string;
  }
> = {
  SYNCED: {
    variant: "default",
    label: "Sincronizada",
    icon: CheckCircle2,
    className: "bg-green-500 hover:bg-green-600",
  },
  DIVERGENT: {
    variant: "default",
    label: "Divergente",
    icon: AlertTriangle,
    className: "bg-yellow-500 hover:bg-yellow-600 text-yellow-950",
  },
  NOT_FOUND_IN_STORE: {
    variant: "destructive",
    label: "Não encontrada na loja",
    icon: XCircle,
  },
  UNREACHABLE: {
    variant: "secondary",
    label: "Inacessível",
    icon: WifiOff,
  },
};

export function ComparisonStatusBadge({
  status,
  className,
}: ComparisonStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={cn(config.className, className)}>
      <Icon className="mr-1 h-3 w-3" />
      {config.label}
    </Badge>
  );
}
